import { render } from "./SpeciesZoom.vue?vue&type=template&id=1b5d466b&scoped=true"
import script from "./SpeciesZoom.vue?vue&type=script&lang=js"
export * from "./SpeciesZoom.vue?vue&type=script&lang=js"

import "./SpeciesZoom.vue?vue&type=style&index=0&id=1b5d466b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5d466b"]])

export default __exports__